const mageEquipmentList = {
  "Tradycja Bestii": {
    equipment: {
      "Broń wielka": [10, 0],
      Bicz: [15, 0],
      Kostur: [5, 0],
      Sztylet: [2, 0],
      "Topór bojowy/Nadziak": [5, 0],
      Włócznia: [10, 0],
      "Broń miotana": [10, 1],
      Łuk: [10, 1],
      Oszczep: [15, 1],
    },
    skills: [0, 2, 3, 5],
  },
  "Tradycja Cienia": {
    equipment: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana": [10, 1],
    },
    skills: [0, 2, 4, 5],
  },
  "Tradycja Metalu": {
    equipment: {
      "Kadzielnica Ognia": [20, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana": [10, 1],
    },
    skills: [0, 2, 3, 5],
  },
  "Tradycja Niebios": {
    equipment: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana": [10, 1],
    },
    skills: [0, 2, 4, 5],
  },
  "Tradycja Ognia": {
    equipment: {
      "Broń wielka": [10, 0],
      "Kadzielnica Ognia": [20, 0],
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana": [10, 1],
    },
    skills: [0, 2, 3, 5],
  },
  "Tradycja Śmierci": {
    equipment: {
      Kosa: [15, 0],
      Kostur: [5, 0],
      Sztylet: [2, 0],
      "Broń miotana": [10, 1],
    },
    skills: [0, 2, 4, 5],
  },
  "Tradycja Światła": {
    equipment: {
      Kostur: [5, 0],
      Miecz: [10, 0],
      Sztylet: [2, 0],
      "Broń miotana": [10, 1],
    },
    skills: [0, 2, 4, 5],
  },
  "Tradycja Życia": {
    equipment: {
      Kostur: [5, 0],
      Sztylet: [2, 0],
      "Broń miotana": [10, 1],
    },
    skills: [0, 2, 3, 5],
  },
  "Magia Żywiołów": {
    equipment: {
      Kostur: [5,0],
      Chopesz: [10,0],
      Sztylet: [2,0],
      "Broń miotana (noże)": [10,1]
    },
    skills: [0, 2, 4, 5],
  },
};

export default mageEquipmentList;
